import { cloudApiClient } from '@/services/clientSideCloudApiService';
import { JsonSchema } from '@jsonforms/core';

export interface PBROption {
  config: {
    cmd: boolean;
    property: string;
    requiresValue: boolean;
  };
  description: string;
  display_name: string;
  type: 'text' | 'boolean' | 'dropdown';
  order: number;
  options: {
    placeholder: string;
    default?: string;
    values?: {
      name: string;
      value: string;
    }[];
  };
}

export interface RPDXImportOption {
  schema_path: string;
  option_subschema: JsonSchema;
  for_model_types: string[];
}

export const getRapidPbrOptions = async function () {
  const response = await cloudApiClient.get<PBROption[]>('rapidpbr/options');
  return response.data;
};

export const getCadOptions = async function () {
  const response = await cloudApiClient.get<RPDXImportOption[]>('import/rpdx_options');
  return response.data.filter((option) => option.for_model_types.includes('CAD'));
};
